<template>
  <div>
    <yuimg v-if="!strBase64" class="bg" :src="zhanweipic"></yuimg>
    <img v-if="strBase64" class="bg biaodanziduan" :ziduanname="ziduanname" style="object-fit:contain;background:#FFF;"
      :src="strBase64" />
    <input class="bg" ref="fileBtn" style="opacity: 0" type="file" @change="uploadImg" />
  </div>
</template>
<script>
// <fileuploadraw ziduanname="pic" zhanweipic="1/1.jpg" ></fileuploadraw>
import { mapState } from "vuex";
import { tanc } from "@/commonjs/commonfn.js";
export default {
  name: "fileuploadraw",
  props: ["ziduanname", "zhanweipic"],
  data() {
    return {
      strBase64: "",
    };
  },
  mounted() { },
  methods: {
    /**
  * 图片压缩，默认同比例压缩
  * @param {Object} path
  * pc端传入的路径可以为相对路径，但是在移动端上必须传入的路径是照相图片储存的绝对路径
  * @param {Object} obj
  * obj 对象 有 width， height， quality(0-1)
  * @param {Object} callback
  * 回调函数有一个参数，base64的字符串数据
  */
    dealImage(path, obj, callback) {
      var img = new Image();
      img.src = path;
      img.onload = function () {
        var that = this;
        // 默认按比例压缩
        var w = that.width,
          h = that.height,
          scale = w / h;
        w = obj.width || w;
        h = obj.height || (w / scale);
        var quality = 0.7; // 默认图片质量为0.7
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 创建属性节点
        var anw = document.createAttribute("width");
        anw.nodeValue = w;
        var anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality;
        }
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        callback(base64);
      }
    },
    uploadImg() {
      var that = this;
      var inputFile = this.$refs.fileBtn.files[0];

      if (inputFile) {
        if (
          inputFile.type !== "image/jpeg" &&
          inputFile.type !== "image/png" &&
          inputFile.type !== "image/gif"
        ) {
          tanc("不是有效的图片文件！");
          return;
        }
        // if (inputFile.size > 1024 * 20) {
        //   console.log(inputFile.size);
        //   tanc("请上传小于 12KB 的图片 ！");
        //   return;
        // }

        const reader = new FileReader();

        reader.readAsDataURL(inputFile); // 读出 base64
        reader.onload = () => {
          // 图片的 base64 格式, 可以直接当成 img 的 src 属性值
          const _base64 = reader.result;
          console.log(_base64);
          that.dealImage(_base64, { width: 750 }, function (base) {
               that.strBase64 = base;
          });
     
        };
        return false;
      } else {
        return;
      }
    },
  },
  computed: {
    ...mapState([
      "suodingtipcss",
      "yujiazaicss",
      "sharetipcontainercss",
      "morentanchuangcss",
      "chuangtitle",
      "fn",
      "jindu",
      "starcss",
      "isalljiazai",
      "isplaybgmusic",
    ]),
  },
};
</script>
<style scoped>
.showimg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}

.uploadinput {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/fileuploadraw.vue